import React from 'react'

/**
 * Layout shell for the timeline sidebar. Pass route-specific blocks (e.g. project/scenario asset lists) as children.
 * @param {string} [shellClassName] — appended to the outer shell (e.g. min-h-0 for flex-embedded layouts).
 */
export default function TimelineSidebar({ children, shellClassName = '' }) {
  return (
    <div className={`w-[323px] h-full min-h-0 border-r border-rb-light-gray dark:border-rb-dark-mode-lighter bg-rb-grey dark:bg-rb-dark-mode overflow-y-auto p-4 ${shellClassName}`}>
      <div className='pb-16'>{children}</div>
    </div>
  )
}
